import { useEngagementTrackingQuery } from '@anytag/graphql';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { TrackingUrl } from '@anytag/shared-organisms';
import { useEngagementDetailsContext } from '../engagement-details-context';

export const EngagementTrackingUrl = () => {
  const { engagementId } = useEngagementDetailsContext();
  const { data, loading } = useEngagementTrackingQuery({ fetchPolicy: 'cache-first', variables: { engagementId } });

  return (
    <RenderDataWithFallback loading={loading}>
      <TrackingUrl postbackUrl={data?.engagementTracking?.postbackUrl} />
    </RenderDataWithFallback>
  );
};
